// imports
import { atom } from 'jotai'

// lib files
import { DefaultSearchFiltersObject, SearchFiltersObject } from '@/lib/content-services/search/search'

const searchFiltersAtom = atom<SearchFiltersObject>(DefaultSearchFiltersObject)

export { searchFiltersAtom }
